import { useQuestionaireRoute } from './useQuestionaireRoute';

/**
 * Resolves the share-link JWT for the current questionnaire route.
 *
 * In the agency/DPO share-link flow the questionnaire is opened with a
 * `?token=` share-token id which is exchanged asynchronously for a signed JWT.
 * Data hooks used inside the questionnaire must forward this JWT so that
 * company-scoped resolvers work without an authenticated user session.
 *
 * Returns:
 * - `token`: the resolved JWT, or `undefined` in the authenticated flow (no
 *   share token in the URL) or while the JWT is still being fetched.
 * - `waitingForShareToken`: `true` while a share token is present in the URL
 *   but its JWT has not resolved yet. Queries should be skipped until then to
 *   avoid firing an unauthenticated request that fails with "Not authenticated".
 */
export function useShareTokenJwt(): { token: string | undefined; waitingForShareToken: boolean } {
  const { currentParams, jwt } = useQuestionaireRoute();
  return {
    token: jwt ?? undefined,
    waitingForShareToken: !!currentParams.token && !jwt,
  };
}
